(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsConversation', rmsConversation);

    function rmsConversation() {
        return {
            restrict: 'E',
            scope: {
                refresh: '=?',
                options: '='
            },
            controller: rmsConversationCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/conversation',
        };
    }

    function rmsConversationCtrl(GenericModel, lodash, EventsRunner) {
        var vm = this;
        this.$onInit = function() {
            vm.refresh = refresh;

            lodash.set(vm.options, 'conversation_option.submitReply', submitReply);
        }

        function refresh(dataItem) {
            vm.dataItem = dataItem;

            const ds = decodeURI(vm.options.datasource.url).replace(new RegExp('<conversation_id>', 'g'), vm.dataItem.id);
            const method = lodash.get(vm.options.datasource, 'method', 'get');
            const rsc = GenericModel(ds);
            rsc[method]().$promise.then(function(res) {
                vm.data = res.rows;
            });
        }

        function submitReply(data) {
            const promise = EventsRunner(vm.options.events, vm.options.event_trigger.submit_reply, data);
            promise.then(function(res) {
                if (!!res && !(lodash.has(res, 'status') && res.status === 422)) {
                    refresh(vm.dataItem);
                    angular.element('.grid-detail-content').animate({
                        scrollTop: 0
                    }, 500);
                }
            });
            return promise;
        }
    }
})();